module.exports = __webpack_public_path__ + "img/paul_92.2964eab4.jpg";